module.exports = __webpack_public_path__ + "9425a74a72d4aee93efc6bbbf7826ede.fbx";